import React from 'react';
import { withRouter } from 'react-router-dom';

class VisualizarConta extends React.Component {

    constructor() {

        super();

        this.state = {
            centro: "",
            centroId: 0,
            id: "",
            codConta: "",
            conta: "",
            tipoConta: "",
            tipoContaId: "",
            naturezaConta: "",
            cultura: "",
            investimento: ""
        };

        this.editar = this.editar.bind(this);
        this.orcamento = this.orcamento.bind(this);
        this.voltar = this.voltar.bind(this);

    }

    formatarInvestimento(n) {

        if (n === 1) return "Aplicação";
        else if (n === 2) return "Resgate";
        else if (n === 3) return "Rendimento";
        else return "Não";

    }

    editar() {

        let obj = {
            id: this.state.id,
            codConta: this.state.codConta,
            conta: this.state.conta,
            tipoConta: this.state.tipoConta,
            tipoContaId: this.state.tipoContaId,
            naturezaConta: this.state.naturezaConta,
            cultura: this.state.cultura,
            investimento: this.state.investimento,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/editarconta",
            state: obj
        });

    }

    orcamento() {

        let obj = {
            id: this.state.id,
            codConta: this.state.codConta,
            conta: this.state.conta,
            tipoConta: this.state.tipoConta,
            tipoContaId: this.state.tipoContaId,
            naturezaConta: this.state.naturezaConta,
            cultura: this.state.cultura,
            investimento: this.state.investimento,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/orcamento",
            state: obj
        });

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ]
            }
        };

        this.props.history.push({
            pathname: "/contascentro",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let id = this.props.location.state.row.id;
        let codConta = this.props.location.state.row.data[0];
        let conta = this.props.location.state.row.data[1];
        let tipoConta = this.props.location.state.row.data[2];
        let naturezaConta = this.props.location.state.row.data[3];
        let cultura = this.props.location.state.row.data[4];

        this.setState({ id: id });
        this.setState({ codConta: codConta });
        this.setState({ conta: conta });
        this.setState({ tipoConta: tipoConta });
        this.setState({ naturezaConta: naturezaConta });
        this.setState({ cultura: cultura });

        fetch("/api/centro/centroconta/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centro: responseJson.nome });
            this.setState({ centroId: responseJson.id });

            fetch("/api/tipo_conta/conta/" + id, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ tipoContaId: responseJson2.id });

                fetch("/api/conta/" + id, {
                    method: "GET",
                    headers: {
                        "Content-type": "application/json",
                        "Authorization": "Basic " + btoa(localStorage.auth)
                    },
                    mode: "cors"
                })
                .then(response3 => response3.json())
                .then(responseJson3 => {

                    this.setState({ investimento: responseJson3.investimento });

                });

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="visualizar-conta-title">Conta</h1><br /><br />
                <p id="visualizar-conta-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <table id="visualizar-conta-table">
                    <tbody>
                        <tr>
                            <td><b>Código:</b></td>
                            <td>{ this.state.codConta }</td>
                        </tr>
                        <tr>
                            <td><b>Conta:</b></td>
                            <td>{ this.state.conta }</td>
                        </tr>
                        <tr>
                            <td><b>Tipo de Conta:</b></td>
                            <td>{ this.state.tipoConta }</td>
                        </tr>
                        <tr>
                            <td><b>Natureza da Conta:</b></td>
                            <td>{ this.state.naturezaConta }</td>
                        </tr>
                        <tr>
                            <td><b>Cultura:</b></td>
                            <td>{ this.state.cultura }</td>
                        </tr>
                        <tr>
                            <td><b>Investimento:</b></td>
                            <td>{ this.formatarInvestimento(this.state.investimento) }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <button Class="visualizar-conta-btn"
                    id="visualizar-conta-voltar-btn"
                    onClick={ this.voltar }>Voltar</button>
                { localStorage.roleContas === "escrever" &&
                    <button Class="visualizar-conta-btn"
                        id="visualizar-conta-editar-btn"
                        onClick={ this.editar }>Editar</button> }
                <button Class="visualizar-conta-btn"
                    id="visualizar-conta-orcamento-btn"
                    onClick={ this.orcamento }>Orçamento</button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarConta);

